import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";
import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";

export interface PdfTemplates {
    css?: string;
    header?: string;
    body?: string;
    footer?: string;
}

/**
 * @title PDF configuration
 * @additionalProperties false
 * @format custom-pdf-configuration
 */
@ValuesConfigurationConstructor(ConfigurationValues.Pdf)
@ComponentConfigurationClass("pdfConfiguration")
export class PdfConfiguration {
    public enabled?: boolean;
    public pdfTemplates?: PdfTemplates;
    public bundlePdfTemplates?: PdfTemplates;
}
